import colors from "tailwindcss/colors";

import ToggleSwitch from "@components/toggle-switch/toggle-switch";
import InfoTooltip from "@components/tooltip/info-tooltip";
import { classNames } from "@helpers/css";

const ToggleCard = ({
  enabled,
  title,
  settings,
  disabled,
  infoTooltip,
  toggleTooltip,
  onChange,
}: {
  enabled: boolean;
  title: string;
  settings?: React.ReactNode;
  disabled?: boolean;
  infoTooltip?: string;
  toggleTooltip?: string;
  onChange: (enabled: boolean) => void;
}) => {
  return (
    <div
      className={classNames(
        "border rounded-lg px-4 py-4 flex justify-between",
        enabled && "border-blue-100 bg-sky-50",
        !enabled && "border-transparent bg-white tf-dashed-8-8",
      )}
    >
      <div className="shrink-0 flex gap-3 flex-1">
        <div className="shrink-0">
          <ToggleSwitch
            disabled={disabled}
            tooltip={toggleTooltip}
            checked={enabled}
            onChange={onChange}
            activeColor={colors.blue[600]}
            aria-label={title}
          />
        </div>
        <div className="flex-1">
          <div className="tf-header-sm">{title}</div>
          <div className="mt-3 empty:hidden">{settings}</div>
        </div>
      </div>
      {infoTooltip ? (
        <InfoTooltip text={infoTooltip} />
      ) : (
        <div className="w-4"></div>
      )}
    </div>
  );
};

export default ToggleCard;
